var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdentificationBadge2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4226 14.4388C17.1977 14.2898 18.9735 14.2079 20.75 14.2079C22.5265 14.2079 24.3031 14.2898 26.0774 14.4388C26.2189 16.2913 26.2979 18.1453 26.2979 20.0001C26.2979 21.8548 26.2197 23.7096 26.0774 25.5613C24.3023 25.7103 22.5265 25.7922 20.75 25.7922C18.9735 25.7922 17.1969 25.7103 15.4226 25.5613C15.2811 23.7088 15.2021 21.8548 15.2021 20.0001C15.2021 18.1453 15.2804 16.2906 15.4226 14.4388Z",
    fill: "#F5D768"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9522 5.87672C28.4937 7.31134 28.9514 8.77627 29.3227 10.2641C29.3749 10.4741 29.4218 10.6849 29.4717 10.8957C29.6728 10.9479 29.874 10.9948 30.0751 11.0499C31.5049 11.4403 32.9092 11.9189 34.2799 12.4831C32.846 9.6771 30.6375 7.37095 27.9514 5.87598",
    fill: "#020303"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.922 4.50354C16.4858 6.3643 16.1368 8.24444 15.8762 10.1378C17.491 9.91175 19.1194 9.79627 20.75 9.79218C22.3798 9.79662 24.0074 9.91209 25.6215 10.1378C25.362 8.24402 25.013 6.36358 24.5757 4.50279C23.3533 4.17505 22.0721 4 20.7507 4C19.4293 4 18.1466 4.17505 16.922 4.50354Z",
    fill: "#007599"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5283 19.9996C30.5235 21.7007 30.4125 23.3999 30.196 25.0872C32.0128 24.8142 33.8145 24.4493 35.5942 23.9937C35.9085 22.717 36.0761 21.3792 36.0761 19.9996C36.0761 18.6201 35.9085 17.2808 35.5942 16.0034C33.8149 15.5475 32.0134 15.1833 30.1968 14.9121C30.4128 16.597 30.5245 18.2983 30.5283 19.9996Z",
    fill: "#A5AEA1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5779 35.4972C25.0141 33.6362 25.3631 31.7558 25.6237 29.8622C24.0088 30.0871 22.3797 30.2048 20.75 30.2078C19.1197 30.2033 17.4916 30.0878 15.877 29.8622C16.1377 31.7559 16.4872 33.6363 16.9243 35.4972C18.1459 35.8249 19.427 36 20.7492 36C22.0706 36 23.3533 35.8257 24.5779 35.4972Z",
    fill: "#849A3F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2785 27.5188C32.908 28.0818 31.5043 28.5599 30.0751 28.9505C29.874 29.0056 29.6729 29.0548 29.4703 29.1047C29.4211 29.3155 29.3749 29.5263 29.3228 29.7356C28.9494 31.2238 28.4911 32.6894 27.95 34.1252C30.6375 32.6294 32.8461 30.3233 34.2792 27.5181M13.5477 34.1244C13.0064 32.6892 12.5487 31.2238 12.1771 29.7356C12.125 29.527 12.0781 29.3147 12.0282 29.1039C11.827 29.0518 11.6259 29.0049 11.4248 28.9497C9.99506 28.5592 8.59078 28.0809 7.21997 27.5173C8.65386 30.3218 10.8617 32.6272 13.5477 34.1244Z",
    fill: "#020303"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.90527 16.0059C5.58514 17.3132 5.42358 18.6542 5.42407 20C5.42407 21.3803 5.59167 22.7188 5.90601 23.9963C7.69745 24.4581 9.50154 24.8156 11.3034 25.0883C11.0868 23.401 10.9761 21.7018 10.9719 20.0007C10.9764 18.3002 11.0881 16.5989 11.3034 14.9132C9.5008 15.1873 7.6967 15.5456 5.90527 16.0059Z",
    fill: "#F26D3A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0293 10.8948C12.0777 10.6847 12.1246 10.4732 12.1768 10.2638C12.5501 8.77562 13.0085 7.31003 13.5496 5.87427C10.8613 7.36999 8.65276 9.67539 7.21887 12.4813C8.58934 11.9176 9.99339 11.4392 11.423 11.0489C11.6241 10.9946 11.8267 10.9462 12.0293 10.8948Z",
    fill: "#020303"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentificationBadge2);
export default __webpack_public_path__ + "static/media/IdentificationBadge2.ebcadf89aab83452ee3e2bf59e03c393.svg";
export { ForwardRef as ReactComponent };